import React from "react";
import clsx from "clsx";
import LandingGlyph, { type LandingGlyphName } from "./LandingGlyph";

export type LandingStat = {
  value: string;
  label: string;
  detail: string;
  glyph: LandingGlyphName;
};

export type LandingStatBandProps = React.ComponentPropsWithoutRef<"section"> & {
  stats: LandingStat[];
};

const LandingStatBand: React.FC<LandingStatBandProps> = ({ stats, className, ...props }) => {
  return (
    <section className={clsx("bg-white px-4 pt-10 pb-2 sm:px-6 lg:px-10", className)} {...props}>
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto grid max-w-5xl gap-3 rounded-2xl border border-myteengig-border/70 bg-[linear-gradient(135deg,#F4FBFF_0%,#FFFFFF_45%,#F0FDF9_100%)] p-4 shadow-[0_18px_50px_rgba(10,70,102,0.08)] sm:grid-cols-2 sm:p-5 lg:grid-cols-3">
          {stats.map((stat) => (
            <article
              key={stat.label}
              className="group flex items-start gap-3 rounded-xl border border-white/80 bg-white/85 p-4 shadow-sm backdrop-blur transition duration-200 hover:-translate-y-0.5 hover:border-myteengig-primary/30 hover:shadow-md"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-myteengig-primary/10 text-myteengig-primary transition group-hover:bg-myteengig-primary group-hover:text-white">
                <LandingGlyph name={stat.glyph} className="h-6 w-6" />
              </span>
              <div className="min-w-0">
                <p className="text-2xl leading-7 font-black text-myteengig-text-primary">{stat.value}</p>
                <p className="mt-0.5 text-sm font-bold text-myteengig-text-primary">{stat.label}</p>
                <p className="mt-1 text-xs leading-5 text-myteengig-text-muted">{stat.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingStatBand;
